import * as React from "react";
import 'intersection-observer';
import { Action, IOWidget, mk_widget, AsyncState, async } from "widgets-for-react";
import { CMSState, Link } from "../../../../cms/blocks/types.gen";
import { getClassName, link } from "../../../../cms/blocks/utils.gen";
import { ExtraImages } from "../../../utils/extra_images.mod";
import { getDrupalLanguage, PublicSite_CustomPageData } from "../../../application.mod";
import { PublicSiteState } from "../../../../../public_site.main.mod";
import { ParsedImageFileWithTargetItem } from "../../../../drupal/types_and_parser/types";
import { storiesBlockData, CustomBlockData } from "../types.mod";
import { ParsedNodeStory } from "../../../../drupal/types_and_parser/types";
import { PaginatedItem } from "../../../../drupal/types_and_parser/extra_types.mod";
import { storyItem } from "../../../custom_pages/story_overview";
import { getLangFromUrl } from "../../../utils/history.mod";

export type storiesBlockProps = {
  block_index: number
  stories: AsyncState<PaginatedItem<ParsedNodeStory>>
  title: string
  link: Link
}

export type story = {
  title: string
  introduction?: string
  image?: ParsedImageFileWithTargetItem
  link?: Link
}

export type storiesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function storiesBlock(
  props: storiesBlockProps,
  options?: { style: storiesBlockStyle; key?: string }
): (s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: setState => {
        return (
          <section className="block block--stories">
            <div className="block__inner">
              {props.title ? (
                <header className="block__header container container--s grid--gutter">
                  {props.title && <h2 className="block__title title--l">{props.title}</h2>}
                </header>
              )
                : <></>
              }


              <div className="block__content">
                {async()(props.stories).run(a => {
                  setState(s0 => {
                    let block = s0.blocks.get(props.block_index) as storiesBlockData;
                    block.value.fst.stories = a(block.value.fst.stories) as AsyncState<PaginatedItem<ParsedNodeStory>>;
                    return { ...s0, blocks: s0.blocks.set(props.block_index, block) }
                  })
                })}
                {props.stories.kind == 'loaded'
                  ? <div className="block__container container container--m grid--gutter">
                    <ul className="block__list grid">
                      {props.stories.value.items.slice(0, 3).map(story => {
                        return storyItem(story, getDrupalLanguage(getLangFromUrl()))
                      })}
                    </ul>
                  </div>
                  : props.stories.kind}

                {props.link &&
                  <footer className='block__footer container container--m grid--gutter'>
                    {link(props.link, { classname: "button button--primary" }, props.link.title)}
                  </footer>
                }
              </div>
            </div>
          </section>
        )
      },
    })
}

const story = (story: story, options?: { style: storiesBlockStyle; key?: string }) =>
  <div>
    <h3>{story.title}</h3>
    {story.introduction && <div dangerouslySetInnerHTML={{ __html: story.introduction }} />}

    {story.image && <img src={story.image.image.style_urls.grid} alt={story.image.alt} />}

    {story.link &&
      <footer className={getClassName(options, "footer_classname", "")}>
        <div className={""}> {/* TODO : Set classname*/}
          {link(story.link, { classname: "classname" } /* TODO : Set classname */, story.link.title)}
        </div>
      </footer>
    }
  </div>